<template>
  <div id="top">
    <body class="-home">
    <header class="c_hd">
      <h1 class="c_hd_logo" href="./">
        <img src="./assets/img/cmn/logo.svg" alt="Predeter JC3" width="171" height="23">
        <span class="vis-hide">認証ポータル</span>
      </h1>
      <div class="c_hd_user">
        <button class="c_hd_user_btn" type="button">
          <p style="color: #ffffff">　　　　'</p>
          <div class="c_hd_user_name" >{{ belonging }}</div>
        </button>
        <nav class="c_hd_user_menu" >
          <ul class="c_hd_user_menu_list" >
            <li @click="changePassword()"><a>パスワード変更</a></li>
            <li @click="logout()"><a>ログアウト</a></li>
          </ul>
        </nav>
      </div>
      <nav class="c_hd_btn" v-if ="dev || manager" >
        <a href="/admin"><i class="icon-setting"></i><span class="vis-hide">設定</span></a>
      </nav>
    </header>
    <div class="c_wrap">
      <main class="c_cnt">
        <div class="c_main">
          <section class="info">
            <h2 class="info_ttl"><i class="icon-info"></i>お知らせ</h2>
            <div class="info_cnt">
              <ul id="info_list" class="info_list">
                <el-carousel :interval="7000" arrow="always">
                    <el-carousel-item v-for="announce in announces" :key="announce.title">
                      <div class="body">
                        <h1 class="title">{{ announce.title }}</h1>
                        <div id="announce-markdown" v-html="announceHTML(announce)"></div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>                
              </ul>
            </div>     
            <div class="info_count">
            </div>            
          </section>
                    
          <div class="menu">
            <ul class="menu_list">
              <li class="menu_item" v-for="app in applications" v-bind:key="app.id">
                <a class="menu_item_wrap" @click="onClickApplication(app)">
                  <div class="menu_item_img"><img v-bind:class="{disabled: !app.enabled}" :src="iconImageUrl(app.id)" alt="" width="303" height="160" ></div>
                  <p class="menu_item_ttl">{{app.name}}</p>
                </a>
              
              </li>
            </ul>
          </div>

          <!-- <div class="recruit">
            <a class="recruit_btn" href="aaa">
              <span>追加希望募集中</span>
              <img src="./assets/img/home/recruit@2x.png" alt="" width="210" height="141">
            </a>
          </div> -->

        </div>
        <footer class="c_copy">
          <small>© JC3 All rights reserved.</small>
        </footer>
      </main>
    </div>
    </body>    
  </div>
</template>

<script>
import axios from "axios";
import marked from "marked";

export default {
  data() {
    const endpointUrl = "/api/consumers/available/";

    return {
      endpointUrl,
      applications: [],
      install_guide_url :"/api/consumers/manuals/install_guide/",
      install_exists : false,
      user_guide_url :"/api/consumers/manuals/users_guide/",
      user_exists : false,
      tutorial_guide_url :"/api/consumers/manuals/tutorial_guide/",
      tutorial_exists : false,
      movie_guide_url :"/api/consumers/manuals/movie_guide/",
      movie_exists : false,
      movie_darkweb_url :"/api/consumers/manuals/movie_darkweb/",
      movie_darkweb_exists : false,
      movie_slung_url :"/api/consumers/manuals/movie_slung/",
      movie_slung_exists : false,
      movie_search_url :"/api/consumers/manuals/movie_search/",
      movie_search_exists : false,
      movie_undercover_url :"/api/consumers/manuals/movie_undercover/",
      movie_undercover_exists : false,
      movie_whitelist_url :"/api/consumers/manuals/movie_whitelist/",
      movie_whitelist_exists : false,
      movie_investigate_url :"/api/consumers/manuals/movie_investigate/",
      movie_investigate_exists : false,
      movie_blacklist_url :"/api/consumers/manuals/movie_blacklist/",
      movie_blacklist_exists : false,
      movie_crawler_url :"/api/consumers/manuals/movie_crawler/",
      movie_crawler_exists : false,
      movie_history_url :"/api/consumers/manuals/movie_history/",
      movie_history_exists : false,
      movie_bookmark_url :"/api/consumers/manuals/movie_bookmark/",
      movie_bookmark_exists : false,
      movie_setting_url :"/api/consumers/manuals/movie_setting/",
      movie_setting_exists : false,
      announceEndpointUrl: "/api/consumers/postableannounces/",
      announces: [],
      announce: {},
      manager:false,
      dev:false,
      nickname :"",
    };
  },
  created() {
    this.fetchApplications();
    this.fetchAnnounceData();

  },
  mounted(){    
  },
  computed: {
    belonging: function() {
      console.log(this.$store.getters.loginStatus)
      if (this.$store.getters.loginStatus.role_name.includes("NEC管理者") ||
          this.$store.getters.loginStatus.role_name.includes("開発担当者")) {
        this.dev = true
        this.manager = true
      }
      else if (this.$store.getters.loginStatus.role_name.includes("ユーザ内管理者")) {
        this.manager = true
        this.dev = false
      }
      else{
        this.dev = false
        this.manager = false
      }
      this.nickname = this.$store.getters.loginStatus.nickname    
      return this.nickname;
      
    }
  },  
  methods: {
    changePassword() {
      this.$router.push({ name: "changePassword" });
    },
    logout() {
      axios.get("/api/accounts/logout/").then(() => {
        this.$router.push({ name: "login" });
      });
    },    
    announceHTML(announce) {
      if ("body" in announce) {
        return marked(announce.body);
      } else {
        return "";
      }
    },
    fetchAnnounceData() {
      console.log("Fetch announce data.");

      axios
        .get(this.announceEndpointUrl)
        .then(response => {
          this.announces = Object.assign([], response.data);
          this.announce = Object.assign({}, this.announces[0]);
        })
        .catch(error => {
          console.log(error);
        });
    },

    fetchApplications() {
      axios.get(this.endpointUrl).then(response => {
        this.applications = response.data;
      });
    },
    onClickApplication(app) {
      if (app.enabled) {
        window.open(app.login_url, "_blank");
      } else {
        window.open(app.inquiry_url, "_blank");
      }
    },
    iconImageUrl(id) {
      return `/api/consumers/icons/${id}/`;
    },
  }
};
</script>

<style>
@import "./assets/css/style.css";
@import "./assets/css/home.css";
</style>

<!-- <style scoped>
.el-button {
  border-radius: 8px;
}
.icon {
  padding-left: 20px;
  display: inline-block;
  line-height: 90px;
  vertical-align: middle;
}

.button-title {
  display: inline-block;
  width: 100%;
  vertical-align: middle;
  margin: auto;
}

.flex-container {
  display: flex;
  flex-direction: row; /* デフォルト値 */
  align-items: flex-start;
  flex-wrap: wrap; /* デフォルト値 */
  align-content: stretch; /* デフォルト値 */
  text-align: center;
  margin: 20px;
}
.flex-container-manual {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
    -webkit-align-items: flex-end;
    align-items: flex-start;
    height: 0px;
    padding-left: 0px;

}
.flex-item {
  text-align: center;
  flex-grow: 0; /* デフォルト値 */
  flex-shrink: 1; /* デフォルト値 */
  flex-basis: auto; /* デフォルト値 */
  padding: 16px;
}
.cypt-manual{
  width: auto;
  padding-left: 0px;
  text-align:center;
}
.contents{
  text-align:center;
}
.announce-area{
  width: 1000px;
  padding-left: 20px;
  text-align:left;
}
.image-button {
  position: relative;
  width: 300px;
  width: 300px;
  height: 350px;
}
.consumer-icon {
  position: relative;
  width: 256px;
  height: 256px;
}
.consumer-icon.disabled {
 display: block;
 opacity: .1;
}
.layer {
  position: absolute;
  right: 8px;
  top: 8px;
  background-color: coral;
  color: white;
  border-radius: 8px;
  padding: 12px;
}
.announce .title {
  color: rgb(1, 44, 99);
  border-bottom: solid 1px rgb(1, 44, 99);
  padding: 0;
  margin: 0;
  text-align:left;
}
.announce {
  width: 100%;
  height: 360px;
  min-height: 360px;
  margin: auto;
}
.announce-header {
  height: 10%;
  min-height: 10%;
}

.announce .body {
  margin: 12px 60px;
  text-align:left;
}
</style> -->

